/**
 * String.prototype.replaceAll() polyfill
 * Pushes support back to IE6
 */
if (!String.prototype.replaceAll) {
	String.prototype.replaceAll = function (string, newString) {
		//If a regex pattern
		if (Object.prototype.toString.call(string).toLowerCase() === '[object regexp]') {
			return this.replace(string, newString);
		}
		//For normal string
		return this.replace(new RegExp(string, 'g'), newString);
	};
}
